import type { TowerJsonSchema } from './towerSchemaToYup';

/**
 * Excess tower JSON Schema (FPX-5829 / FPX-5853), mirroring the `excessTower`
 * RATER_GLOBAL dynamic field seeded in mothership (`V1.13.15`). Scope is
 * well-formedness only: required props, types, positive limit/premium,
 * non-negative retention, co-insurer percentage 0..100.
 *
 * TODO(FPX-5829/5853): replace this hardcoded copy with a fetch of the
 * `excessTower` field schema from the dynamic-field schema API once the BE
 * endpoint that serves a single RATER_GLOBAL field by key is available.
 */
const scalarString = {
  type: ['object'] as const,
  required: ['value'],
  properties: { value: { type: ['string'] as const } },
};

const positiveNumber = {
  type: ['object'] as const,
  required: ['value'],
  properties: { value: { type: ['number'] as const, exclusiveMinimum: 0 } },
};

const nonNegativeNumber = {
  type: ['object'] as const,
  required: ['value'],
  properties: { value: { type: ['number'] as const, minimum: 0 } },
};

const coInsurers = {
  type: ['object'] as const,
  properties: {
    values: {
      type: ['array'] as const,
      items: {
        type: ['object'] as const,
        required: ['props'],
        properties: {
          props: {
            type: ['object'] as const,
            required: ['carrier', 'percentage'],
            properties: {
              carrier: scalarString,
              percentage: {
                type: ['object'] as const,
                required: ['value'],
                properties: {
                  value: { type: ['number'] as const, minimum: 0, maximum: 100 },
                },
              },
            },
          },
        },
      },
    },
  },
};

export const EXCESS_TOWER_SCHEMA: TowerJsonSchema = {
  type: ['object'],
  required: ['props'],
  properties: {
    props: {
      type: ['object'],
      required: ['primary', 'cowbellAttachment'],
      properties: {
        primary: {
          type: ['object'],
          required: ['props'],
          properties: {
            props: {
              type: ['object'],
              required: ['carrier', 'limit', 'retention', 'premium'],
              properties: {
                carrier: scalarString,
                policyNumber: scalarString,
                limit: positiveNumber,
                retention: nonNegativeNumber,
                premium: positiveNumber,
                coInsurers,
                layerPdfDocId: scalarString,
              },
            },
          },
        },
        underlying: {
          type: ['object'],
          properties: {
            values: {
              type: ['array'],
              items: {
                type: ['object'],
                required: ['props'],
                properties: {
                  props: {
                    type: ['object'],
                    required: ['carrier', 'limit', 'premium'],
                    properties: {
                      carrier: scalarString,
                      policyNumber: scalarString,
                      limit: positiveNumber,
                      premium: positiveNumber,
                      coInsurers,
                      layerPdfDocId: scalarString,
                    },
                  },
                },
              },
            },
          },
        },
        cowbellAttachment: {
          type: ['object'],
          required: ['props'],
          properties: {
            props: {
              type: ['object'],
              required: ['limit'],
              properties: {
                limit: positiveNumber,
                premium: positiveNumber,
                layerPdfDocId: scalarString,
              },
            },
          },
        },
      },
    },
  },
};
